export default __webpack_public_path__ + "static/asset-asian-96421a3d6f6f3e4215d61bd36f0b3808.svg";